'use client'

import { useDocumentOps, useDocumentView } from '@/document'
import { Button } from '@/ui/button'
import { ShieldCheckIcon, ShieldIcon } from '@phosphor-icons/react'
import { cn } from '@/lib/tailwind'

interface TrustToggleProps {
  userId: string
}

export function TrustToggle({ userId }: TrustToggleProps) {
  const doc = useDocumentView()
  const ops = useDocumentOps()

  const trustEntry = doc?.trust?.[userId]
  const isTrusted = trustEntry?.trusted ?? false

  const handleToggle = () => {
    ops.setTrust(userId, !isTrusted)
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleToggle}
      className={cn(
        'h-7 gap-1 px-2 text-xs',
        isTrusted
          ? 'text-green-500 hover:text-green-400'
          : 'text-muted-foreground hover:text-foreground',
      )}
    >
      {isTrusted ? (
        <>
          <ShieldCheckIcon className="h-3.5 w-3.5" weight="fill" />
          Trusted
        </>
      ) : (
        <>
          <ShieldIcon className="h-3.5 w-3.5" />
          Default
        </>
      )}
    </Button>
  )
}
